import script from "./Navigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigation.vue?vue&type=script&lang=ts&setup=true"

import "./Navigation.vue?vue&type=style&index=0&id=46839ca0&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46839ca0"]])

export default __exports__